import {FormattedMessage} from "react-intl";
import FileUploadIcon from "images/library/ic_file_upload.svg";
import styles from "./index.module.scss";

function ItemDragDimmed({onDragLeave, onDrop, onDragOver}) {
  return (
    /* TODO 드래그 드롭 상태일 시, 클래스 styles.drag 추가합니다. */
    <div
      className={styles.item_drop_Area}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onDragOver={onDragOver}
    >
      <div className={`${styles.drag_dimmed} ${styles.drag}`}>
        <div className={styles.inner}>
          <img alt="upload icon" src={FileUploadIcon} />

          <p className={styles.drag_title}>
            <FormattedMessage id="ID_DRAG_DIMMED_TITLE" />
          </p>
          <p className={styles.help_text}>
            <FormattedMessage id="ID_DRAG_DIMMED_HELP_TEXT" />
          </p>
        </div>
      </div>
    </div>
  );
}

export default ItemDragDimmed;
